import { MainStatusCodes, StatusWording } from '../enums/order-status.enums';
import { MainStatusDictionary } from '../models/order-status.types';

export const MainStatusConfig: MainStatusDictionary = {
    [MainStatusCodes.PendingPayment]: {
        title: StatusWording.PendingPayment,
        isSubStatusInfo: false,
        groupKey: StatusWording.PendingPayment,
        order: 1,
    },
    [MainStatusCodes.NoBankComunication]: {
        title: StatusWording.PendingPayment,
        isSubStatusInfo: false,
        groupKey: StatusWording.PendingPayment,
        order: 1,
    },
    [MainStatusCodes.DeniedPayment]: {
        title: StatusWording.DeniedPayment,
        isSubStatusInfo: false,
        groupKey: StatusWording.DeniedPayment,
        order: 2,
    },
    [MainStatusCodes.SyncPayment]: {
        title: StatusWording.Confirmed,
        isSubStatusInfo: false,
        groupKey: StatusWording.Confirmed,
        order: 3,
    },
    [MainStatusCodes.FraudControl]: {
        title: StatusWording.Confirmed,
        isSubStatusInfo: false,
        groupKey: StatusWording.Confirmed,
        order: 3,
    },
    [MainStatusCodes.Confirmed]: {
        title: StatusWording.Confirmed,
        isSubStatusInfo: false,
        groupKey: StatusWording.Confirmed,
        order: 3,
    },
    [MainStatusCodes.InWarehouseE]: {
        title: StatusWording.InWarehouse,
        isSubStatusInfo: false,
        groupKey: StatusWording.InWarehouse,
        order: 4,
    },
    [MainStatusCodes.InWarehouseG]: {
        title: StatusWording.InWarehouse,
        isSubStatusInfo: false,
        groupKey: StatusWording.InWarehouse,
        order: 4,
    },
    [MainStatusCodes.InssuficientInventory]: {
        title: StatusWording.InWarehouse,
        isSubStatusInfo: false,
        groupKey: StatusWording.InWarehouse,
        order: 4,
    },
    [MainStatusCodes.Canceled]: {
        title: StatusWording.Canceled,
        isSubStatusInfo: false,
        groupKey: StatusWording.Canceled,
        order: 5,
    },
    [MainStatusCodes.SendedR]: {
        title: StatusWording.Sended,
        isSubStatusInfo: false,
        groupKey: StatusWording.Sended,
        order: 6,
    },
    [MainStatusCodes.SendedS]: {
        title: StatusWording.Sended,
        isSubStatusInfo: false,
        groupKey: StatusWording.Sended,
        order: 6,
    },
    [MainStatusCodes.InCarrierD]: {
        title: StatusWording.InCarrier,
        isSubStatusInfo: false,
        groupKey: StatusWording.InCarrier,
        order: 7,
    },
    [MainStatusCodes.InCarrier]: {
        title: StatusWording.InCarrier,
        isSubStatusInfo: false,
        groupKey: StatusWording.InCarrier,
        order: 8,
    },
    [MainStatusCodes.Rejected]: {
        title: StatusWording.Rejected,
        isSubStatusInfo: false,
        groupKey: StatusWording.Rejected,
        order: 9,
    },
    [MainStatusCodes.Delivered]: {
        title: StatusWording.Delivered,
        isSubStatusInfo: false,
        groupKey: StatusWording.Delivered,
        order: 10,
    },

};
